import React from 'react';
import { DropdownText } from 'Screens/Contextualization/Manage/components/CreateActions/styled';
import { Icon, Wrapper } from './styled';
import { useDispatch } from 'react-redux';
import { downloadCredentials } from 'store/Credentials/actions';

const ExportCSV = ({ isVulnDetail }) => {
  const dispatch = useDispatch();

  return (
    <Wrapper onClick={ () => dispatch(downloadCredentials(isVulnDetail)) }>
      <Icon />
      <DropdownText>Export CSV</DropdownText>
    </Wrapper>
  );
};

export default ExportCSV;
